import React from 'react';

const IconOrcid = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="23 5 20 60"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-orcid">
    <title>ORCID</title>
    <path d="M34.5 6.46875C19.0443 6.46875 6.46875 19.0443 6.46875 34.5C6.46875 49.9557 19.0443 62.5312 34.5 62.5312C49.9557 62.5312 62.5312 49.9557 62.5312 34.5C62.5312 19.0443 49.9557 6.46875 34.5 6.46875ZM34.5 10.7812C47.6251 10.7812 58.2188 21.375 58.2188 34.5C58.2188 47.625 47.6251 58.2188 34.5 58.2188C21.3749 58.2188 10.7812 47.625 10.7812 34.5C10.7812 21.375 21.3749 10.7812 34.5 10.7812ZM23.7188 17.25C23.1469 17.25 22.5984 17.4772 22.1941 17.8816C21.7897 18.2859 21.5625 18.8344 21.5625 19.4062C21.5625 19.9781 21.7897 20.5266 22.1941 20.9309C22.5984 21.3353 23.1469 21.5625 23.7188 21.5625C24.2906 21.5625 24.8391 21.3353 25.2434 20.9309C25.6478 20.5266 25.875 19.9781 25.875 19.4062C25.875 18.8344 25.6478 18.2859 25.2434 17.8816C24.8391 17.4772 24.2906 17.25 23.7188 17.25ZM21.5625 23.7188V47.4375H25.875V23.7188H21.5625ZM30.1875 23.7188V25.875V47.4375H39.8906C46.4145 47.4375 51.75 42.102 51.75 35.5781C51.75 29.0542 46.4145 23.7188 39.8906 23.7188H30.1875ZM34.5 28.0312H39.8906C44.0833 28.0312 47.4375 31.3855 47.4375 35.5781C47.4375 39.7708 44.0833 43.125 39.8906 43.125H34.5V28.0312Z"></path>
  </svg>
);

export default IconOrcid;
